import React, { useState, useEffect } from "react";
import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";
import { useTranslation } from "react-i18next";
import { formatPhoneNumber } from "../lib/Common";

const ModifyGuardian = () => {
    const { t } = useTranslation();
    const [data, setData] = useState({});

    useEffect(() => {
        AuthMe(res => {
            setData(res);
        });
    }, []);

    const clickSave = () => {
        const guard_phones = data.guard_phone?.split(",");
        data.guard_phone = guard_phones.filter(x => x !== "").toString();

        Update(data, res => {
            alert(t("저장을 완료 하였습니다."));
        });
    };

    const guard_phones = data.guard_phone?.split(",");

    return (
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("보호자 정보 수정")}</h2>
                <h3 className="sub_title_sm">Modify Guardian</h3>

                <div className="table_box">
                    <table className="tbl_join small">
                        <caption>{t("보호자 정보 수정")}</caption>
                        <colgroup>
                            <col width="30%" />
                            <col width="70%" />
                        </colgroup>
                        <tbody>
                            {/* <tr>
                                <th>
                                    <label htmlFor="modify_guardian1">보호자1</label>
                                </th>
                                <td>
                                    <div className="form-box">
                                        <input type="number" className="text_nor md w100" placeholder="이름을 입력해주세요" />
                                        <input type="number" className="text_nor md w100" placeholder="휴대전화번호를 입력해주세요" />
                                    </div>
                                    <div className="form-box">
                                        <input type="number" className="text_nor md" id="modify_guardian1" placeholder="보호자 이메일" />
                                        <button type="button" className="btn_nor md line">
                                            등록요청
                                        </button>
                                    </div>
                                </td>
                            </tr> */}
                            {guard_phones?.map((x, idx) => {
                                return (
                                    <tr>
                                        <th>
                                            <label htmlFor="modify_guardian1">
                                                {t("보호자")}
                                                {idx + 1}
                                            </label>
                                        </th>
                                        <td>
                                            <div className="form-box">
                                                <input
                                                    type="text"
                                                    className="text_nor md w100"
                                                    placeholder={t("연락처를 입력해주세요")}
                                                    value={formatPhoneNumber(x)}
                                                    onChange={e => {
                                                        guard_phones[idx] = e.target.value.replace(/-/g, "");
                                                        setData({ ...data, guard_phone: guard_phones.toString() });
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <div className="guardian_add_btns">
                    <button
                        type="button"
                        className="btn_nor line"
                        onClick={() => {
                            setData({ ...data, guard_phone: data.guard_phone + "," });
                        }}
                    >
                        {t("추가하기")}
                    </button>
                </div>

                <div className="btn_bott_box">
                    <a href="/" className="btn_nor line minW">
                        {t("돌아가기")}
                    </a>
                    <a href="javascript:;" className="btn_nor orange minW" onClick={clickSave}>
                        {t("수정하기")}
                    </a>
                </div>
            </div>
        </main>
    );
};

export default ModifyGuardian;
